// @ts-nocheck 

import React, { useState, useEffect } from 'react';
import { Joyride, Step, CallBackProps, STATUS, ACTIONS, EVENTS } from 'react-joyride';
import { UserState, userStore } from '../../api/AuthService';
import { ApiService } from '../../api/ApiService';

interface LayoutProps {
  children: React.ReactNode;
}

const steps: Step[] = [
  // ALL HAPPEN ON Pay PAGE
  {
    content: <h2>Welcome to the Docs Page!</h2>,
    target: 'body',
    placement: 'center',
  },
  {
    target: '#WholeDocsSection',
    content: <h3>The Docs page contains helpful videos and documents related to safety, maintenance, and current permits</h3>,
    disableBeacon: true,
    placement: 'bottom',
  },
  {
    target: '#Accidents',
    content: <h3>This section contains information on what to do after an accident.</h3>,
    disableBeacon: true,
    placement: 'bottom',
  },
];

export default function DocsFirstIn({ children }: LayoutProps) {
  const [run, setRun] = useState(false);
  const [stepIndex,setStepIndex] = useState(0)


//    █████  ██████  ██      ██████  ███████ ████████     ███████ ███████ ████████ 
//   ██   ██ ██   ██ ██     ██       ██         ██        ██      ██         ██    
//   ███████ ██████  ██     ██   ███ █████      ██        ███████ █████      ██    
//   ██   ██ ██      ██     ██    ██ ██         ██             ██ ██         ██    
//   ██   ██ ██      ██      ██████  ███████    ██        ███████ ███████    ██    
  // This is the appMap variable which will show whether its a person's first time on each page.
  const { appMap } = userStore((state: UserState) => ({ appMap: state.appMap }));

  useEffect(() => {
    if ( appMap && !appMap?.docs) {
      setRun(true)
      
        //TODO: CHANGE THIS TO SET A DIFFERENT SECTION TO TRUE DEPENDING ON PAGE IMPORTANT
      appMap.docs = true; 
      
      ApiService.setDriverMap( "login" , {appMap: JSON.stringify(appMap)} )
    }
  },[])




  // This useffect triggers on every stepindex so it scrolls to the locations of the next element
  useEffect(() => {

      const step = steps[stepIndex]; // Get the current step
      if (step?.target && typeof step.target === 'string') { 
        const targetElement = document.querySelector(step.target);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'instant' as ScrollBehavior, block: 'nearest'});
        }
      }
  }, [stepIndex]);


  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action, index, type, step } = data;
    // console.log(step)

    if (step.spotlightClicks === true) { // THis triggers only if the the spotlightclick os true which is part of the step object inside the data.
      console.log("THIS IS TRUE ITS TRUE ITS TRUE")
      document.body.classList.add('joyride-spotlight-clicks');
    } else {
      document.body.classList.remove('joyride-spotlight-clicks');
    }

    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      setRun(false);
      setStepIndex(0);
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }
  }
  
// ███████ ██████   ██████  ████████ ██      ██  ██████  ██   ██ ████████ 
// ██      ██   ██ ██    ██    ██    ██      ██ ██       ██   ██    ██    
// ███████ ██████  ██    ██    ██    ██      ██ ██   ███ ███████    ██    
//      ██ ██      ██    ██    ██    ██      ██ ██    ██ ██   ██    ██    
// ███████ ██       ██████     ██    ███████ ██  ██████  ██   ██    ██    
  // This useffect will load in all the query listeners for different clicks on the spotlight to trigger different effects depending on whats clicked inside the spotlight
  // tne section inside if (spotlight) can be used to add new stepindex and other functionalities when the clicked spotlight area does contains a specific id or class.
  useEffect(() => {
    const handleSpotlightClick = (event: MouseEvent | TouchEvent) => {
      const spotlight = document.querySelector('.react-joyride__spotlight');
      const target = event.target as HTMLElement;
  
      if (spotlight) {

        // if for the toolbar-image click
        if (target.id === 'toolbar-image') {
          setTimeout(() => { //I named all dependencies navbar because I copied and pasted when coding, they're just dependencies
            const navbar = document.querySelector(".sidenav-content"); // added a check for navbar because the index was triggering too fast. (before nav load)s
            const homeButton = document.querySelector("#Home")
            if (navbar && homeButton) {
              setStepIndex((prev) => prev + 1);
            }
          },300); // Adjust timeout just for loading purposes.
        }

        // if for the sidenav-content close back to homepage.
        if (target.id === 'Home') {
          setTimeout(() => {
              setStepIndex((prev) => prev + 1);
          },300); 
        }

        if (target.id === 'HomeMessageLink') {
            setTimeout(() => {
              setStepIndex((prev) => prev + 1);   
            }, 600); 
        }

        if (target.id === 'InboxNotificationLink') {
          setTimeout(() => {
              setStepIndex((prev) => prev + 1);
          },300); 
        }

        if (target.id === 'NotificationHubSettingLink') {
          setTimeout(() => {
              setStepIndex((prev) => prev + 1);
          },300); 
        }

        if (target.id === 'SettingsnavHomeMain') {
          setTimeout(() => {
              setStepIndex((prev) => prev + 1);
          },300); 
        }

        if (target.id === 'HomenavLoadMain') {
          setTimeout(() => {
            const navbar = document.querySelector("#loadPage"); // added a check for navbar because the index was triggering too fast. (before nav load)s
            if (navbar) {
              setStepIndex((prev) => prev + 1);
            }
          },300);     
        }

        if (target.id === 'LoadnavTripMain') {
          setTimeout(() => {
            const navbar = document.querySelector("#AvaTrailer"); // added a check for navbar because the index was triggering too fast. (before nav load)s
            if (navbar) {
              setStepIndex((prev) => prev + 1);
            }
          },300);     
        }

        if (target.id === 'TripnavMoneyMain') {
          setTimeout(() => {
            const navbar = document.querySelector("#WholeMoneySection"); // added a check for navbar because the index was triggering too fast. (before nav load)s
            if (navbar) {
              setStepIndex((prev) => prev + 1);
            }
          },300);     
        }
        
        if (target.id === 'MoneynavDocsMain') {
          setTimeout(() => {
            const navbar = document.querySelector("#WholeDocsSection"); // added a check for navbar because the index was triggering too fast. (before nav load)s
            if (navbar) {
              setStepIndex((prev) => prev + 1);
            }
          },300);     
        }
      }
    };
  
    // Add event listener only if Joyride is running
    if (run) {
      document.addEventListener('click', handleSpotlightClick);
    }
  
    return () => {
      document.removeEventListener('click', handleSpotlightClick);
    };
  }, [run]); 
  


// ██████  ███████ ████████ ██    ██ ██████  ███    ██ 
// ██   ██ ██         ██    ██    ██ ██   ██ ████   ██ 
// ██████  █████      ██    ██    ██ ██████  ██ ██  ██ 
// ██   ██ ██         ██    ██    ██ ██   ██ ██  ██ ██ 
// ██   ██ ███████    ██     ██████  ██   ██ ██   ████ 
  return (
    <div>
      <Joyride
        run={run}
        steps={steps}
        stepIndex={stepIndex}
        onEvent={handleJoyrideCallback}
        continuous
        locale={{ last: 'Finish' }}
        options={{
          arrowColor: 'rgb(238, 238, 238)',
          backgroundColor: 'rgb(238, 238, 238)',
          overlayColor: 'rgba(0, 0, 0, 0.64)',
          primaryColor: '#000',
          textColor: 'rgb(0, 0, 0)',
          width: 900,
          zIndex: 1000,
          buttons: ['primary', 'skip'],
          dismissKeyAction: false,
          overlayClickAction: false,
        }}
        styles={{
          buttonPrimary: {
            fontSize: '1.2rem',
            padding: '10px 25px',
            fontWeight: '700',
          },
          buttonSkip: {
            fontSize: '1.2rem',
            padding: '10px 25px',
            fontWeight: '700',
          }
        }}
      />

      {children}
    </div>
  );
}
